
/**
 * used to set/get strings from local storage
 * @param key the name of the token in storage
 * @param defaultValue used if no token with given key is found in storage
 */
export function LocalStorageString(key: string, defaultValue: string | null) {
  return function (target: Object, decoratedPropertyName: string) {
    Object.defineProperty(target, decoratedPropertyName, {
      get(): string | null {
        const item = localStorage.getItem(key);
        return !item ? defaultValue : item;
      },
      set(newValue: string | null) {
        localStorage.setItem(key, newValue);
      },
    });
  };
}

/**
 * used to set/get booleans from local storage
 * @param key the name of the token in storage
 * @param defaultValue used if no token with given key is found in storage
 */
export function LocalStorageBoolean(key: string, defaultValue: boolean | null) {
  return function (target: Object, decoratedPropertyName: string) {
    Object.defineProperty(target, decoratedPropertyName, {
      get(): boolean | null {
        const item = localStorage.getItem(key);
        return !item ? defaultValue : item.trim() === 'true';
      },
      set(newValue: boolean | null) {
        localStorage.setItem(key, newValue.toString());
      },
    });
  };
}

/**
 * used to set/get numbers from local storage
 * @param key the name of the token in storage
 * @param defaultValue used if no token with given key is found in storage
 */
export function LocalStorageNumber(key: string, defaultValue: number | null) {
  return function (target: Object, decoratedPropertyName: string) {
    Object.defineProperty(target, decoratedPropertyName, {
      get(): number | null {
        const item = localStorage.getItem(key);
        return !item ? defaultValue : Number(item);
      },
      set(newValue: number | null) {
        localStorage.setItem(key, newValue.toString());
      },
    });
  };
}

/**
 * used to set/get objects from local storage
 * @param key the name of the token in storage
 * @param defaultValue used if no token with given key is found in storage
 */
export function LocalStorageObject(key: string, defaultValue: object | null) {
  return function (target: Object, decoratedPropertyName: string) {
    Object.defineProperty(target, decoratedPropertyName, {
      get(): object | null {
        const item = localStorage.getItem(key);
        return !item ? defaultValue : JSON.parse(item);
      },
      set(newValue: object | null) {
        localStorage.setItem(key, JSON.stringify(newValue));
      },
    });
  };
}

/**
 * used to set/get arrays from local storage
 * @param key the name of the token in storage
 * @param defaultValue used if no token with given key is found in storage
 */
export function LocalStorageArray(key: string, defaultValue: any[] | null) {
  return function (target: Object, decoratedPropertyName: string) {
    Object.defineProperty(target, decoratedPropertyName, {
      get(): any[] | null {
        const item = localStorage.getItem(key);
        return !item ? defaultValue : JSON.parse(item);
      },
      set(newValue: any[] | null) {
        localStorage.setItem(key, JSON.stringify(newValue));
      },
    });
  };
}
